import { isValid, isValidArray } from "./utilities";

/**
 * Helpers for OTA partners registered in the travels-server ota_partner
 * registry. Maven's numbers still arrive in the legacy maven* fields of the
 * workflow report, so every helper here deliberately EXCLUDES maven — the
 * partnerActivity map is only consulted for partners onboarded after maven.
 * (The legacy maven handling is deprecated once the registry is proven in
 * production.)
 */

const MAVEN_CODE = 'maven';

/**
 * Whether the logged-in user is a registered OTA partner agent
 * (otaPartnerConfig arrives in the login payload).
 */
export const isOtaPartnerUser = () => {
    return isValid(global.otaPartnerConfig);
};

/**
 * Sum confirmed fares / cancellation-penalty shares of registered partners
 * other than maven from a workflow row's partnerActivity map.
 */
export const getPartnerActivityTotals = (partnerActivity) => {
    let confirmedFare = 0, cancellationPenality = 0;
    if (isValid(partnerActivity)) {
        Object.keys(partnerActivity).forEach((code) => {
            if (code !== MAVEN_CODE && isValid(partnerActivity[code])) {
                confirmedFare += Number(partnerActivity[code].confirmedFare) || 0;
                cancellationPenality += Number(partnerActivity[code].cancellationPenality) || 0;
            }
        });
    }
    return { confirmedFare, cancellationPenality };
};

/**
 * Fold non-maven partner totals into the legacy maven aggregate fields, so
 * every consumer (cost summary, SKU push, settlement) shows the WHOLE OTA
 * partner program - maven included - as QwikBus. Idempotent: an element is
 * folded at most once no matter how many consumers call this, so it is safe
 * to apply both at fetch time and at the settlement boundary.
 */
export const applyPartnerActivityTotalsToElement = (element) => {
    if (!isValid(element) || element._partnerActivityFolded) {
        return element;
    }
    const totals = getPartnerActivityTotals(element.partnerActivity);
    if (totals.confirmedFare > 0 || totals.cancellationPenality > 0) {
        element.mavenConfirmedFare = (Number(element.mavenConfirmedFare) || 0) + totals.confirmedFare;
        element.mavenCancellationPenality = (Number(element.mavenCancellationPenality) || 0) + totals.cancellationPenality;
    }
    element._partnerActivityFolded = true;
    return element;
};

export const applyPartnerActivityTotals = (workFlowSummary) => {
    if (isValidArray(workFlowSummary)) {
        workFlowSummary.forEach((element) => {
            applyPartnerActivityTotalsToElement(element);
        });
    }
    return workFlowSummary;
};
